export const LEGAL_URLS = {
	privacy: 'https://rockstopsolutions.com/grm/privacy/',
	terms: 'https://rockstopsolutions.com/grm/terms/',
} as const;

const linkClass = 'underline hover:text-brand-command transition-colors';

interface LegalLinksProps {
	/** `agree` adds the "By signing in you agree…" sentence; `plain` is just the links; `privacy-only` omits Terms; `privacy-ack` is privacy-only with a "By …, you acknowledge" sentence. */
	variant?: 'agree' | 'plain' | 'privacy-only' | 'privacy-ack';
	/** Wording for the agree sentence ("signing in" vs "entering an access code"). */
	action?: string;
	className?: string;
}

export function LegalLinks({ variant = 'plain', action = 'signing in', className = '' }: LegalLinksProps) {
	const privacy = (
		<a href={LEGAL_URLS.privacy} target="_blank" rel="noopener noreferrer" className={linkClass}>
			Privacy Policy
		</a>
	);
	const terms = (
		<a href={LEGAL_URLS.terms} target="_blank" rel="noopener noreferrer" className={linkClass}>
			Terms of Use
		</a>
	);
	return (
		<p className={`text-micro text-brand-label text-center ${className}`}>
			{variant === 'agree' && <>By {action}, you agree to the {terms} and acknowledge the {privacy}.</>}
			{variant === 'plain' && <>{terms} · {privacy}</>}
			{variant === 'privacy-only' && privacy}
			{variant === 'privacy-ack' && <>By {action}, you acknowledge the {privacy}.</>}
		</p>
	);
}
